import React from 'react';
import moment from 'moment';

import {history} from '../../router';
import {FORMS_URL} from '../../router/urls';
import {getProcessStatus} from "../../helpers";

const SpecialistTable = ({tabInfo, rows}) => {
  const {title} = tabInfo

  const goForm = (opts) => (event) => {
    event.stopPropagation();
    event.preventDefault();

    const {form_type, process_id} = opts;
    history.push(FORMS_URL({form_type, process_id}));
  };

  return (
    <div className="reportbox-content">
      <h4>{title}</h4>
      <div className="line" />
      <table className="table table-hover table-bordered">
        <thead>
        <tr>
          <th>№</th>
          <th>Тема</th>
          <th>Организация</th>
          <th>Дата заявки</th>
          <th>Статус</th>
          <th>Заявитель</th>
        </tr>
        </thead>
        <tbody>
        {rows.length === 0 ? (
          <tr>
            <td colSpan={6} style={{ textAlign: 'center' }}>Нет записей</td>
          </tr>
        ) : rows.map((row, idx) => {
          return (
            <tr className={`report-list-group request-${row.process_id}`} key={idx} onClick={goForm(row)}>
              <td className='label-num-cell'>
                {row.reg_number ?? '-'}
              </td>
              <td>
                {row.subject ?? '-'}
              </td>
              <td>
                {row.name}
              </td>
              <td>
                {row.reg_date ? moment(row.reg_date).format('DD.MM.YYYY') : '-'}
              </td>
              <td>
                {getProcessStatus(row)}
              </td>
              <td>
                {row.email ?? '-'}
              </td>
            </tr>
          )
        })}
        </tbody>
      </table>
    </div>
  );
};

export default SpecialistTable;
